import { useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FiCheckCircle, FiXCircle, FiLoader } from "react-icons/fi";
import axios from "axios";
import MyContext from "../../../context/MyContext";
import "../../../assets/css/customer/customerDashboard/stripe/PaymentSuccess.css";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { baseUrl } = useContext(MyContext);

  const [status, setStatus] = useState("loading");
  const [errorMsg, setErrorMsg] = useState("");

  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    // ── order_id ki jagah ab session_id URL se milega ──
    const session_id = searchParams.get("session_id");

    if (!session_id) {
      setStatus("error");
      setErrorMsg("Checkout data not found. Please contact support.");
      return;
    }

    axios
      .get(`${baseUrl}/customer/order/success`, {
        params: { session_id },
      })
      .then((response) => {
        if (response.data.hasOwnProperty("error")) {
          setStatus("error");
          setErrorMsg(response.data.error);
        } else if (response.data.success == true) {
          setStatus("success");
        } else {
          setStatus("error");
          setErrorMsg(response.data.message || "Order could not be confirmed.");
        }
      })
      .catch(() => {
        setStatus("error");
        setErrorMsg("Something went wrong while confirming your payment.");
      });
  }, [baseUrl, searchParams]);

  return (
    <div className="psuccess-wrapper">
      <div className="psuccess-card">

        {status === "loading" && (
          <>
            <div className="psuccess-icon psuccess-icon-loading">
              <FiLoader size={48} />
            </div>
            <h2 className="psuccess-title">Confirming Your Payment...</h2>
            <p className="psuccess-text">
              Please wait while we finalize your order.
              <br />
              Do not close this page.
            </p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="psuccess-icon psuccess-icon-success">
              <FiCheckCircle size={56} />
            </div>
            <h2 className="psuccess-title">Payment Successful! 🎉</h2>
            <p className="psuccess-text">
              Thank you for your purchase. Your order has been confirmed.
              <br />
              We will deliver it to you soon.
            </p>
            <button
              className="psuccess-btn"
              onClick={() => navigate("/customer/orders")}
            >
              View My Orders
            </button>
            <button
              className="psuccess-btn-outline"
              onClick={() => navigate("/")}
            >
              Continue Shopping
            </button>
          </>
        )}

        {status === "error" && (
          <>
            <div className="psuccess-icon psuccess-icon-error">
              <FiXCircle size={56} />
            </div>
            <h2 className="psuccess-title">Something Went Wrong</h2>
            <p className="psuccess-text">{errorMsg}</p>
            {/* ── Payment complete nahi hui / order remove ho chuka
                hai (backend already cleanup kar chuka hai agar unpaid
                tha) — is liye ab Cart ki bajaye Orders page pe le
                jate hain, taake customer current sahi state dekh sake ── */}
            <button
              className="psuccess-btn"
              onClick={() => navigate("/customer/orders")}
            >
              Go to My Orders
            </button>
          </>
        )}

      </div>
    </div>
  );
};

export default PaymentSuccess;
